export function createQuery(host, type) {
    if(type === 'snmp'){
        return `from(bucket: "telegraf")
            |> range(start:-15m, stop: now())
            |> filter(fn: (r) => r["_measurement"] == "snmp")
            |> filter(fn: (r) => r["_field"] == "sysUpTime")
            |> filter(fn: (r) => r["agent_host"] == "${host}")
            |> map(fn: (r) => ({ r with _value: r._value }))
            |> last()`;
} else{
    return `from(bucket: "telegraf")
            |> range(start:-15m, stop: now())
            |> filter(fn: (r) => r["_measurement"] == "ezelink_uptime_value")
            |> filter(fn: (r) => r["_field"] == "value")
            |> filter(fn: (r) => r["host"] == "${host}")
            |> map(fn: (r) => ({ r with _value: r._value }))
            |> last()`;
}
    }